import { defineStore } from "pinia";
import { useReadSettings, type ReadSettingsResponse } from "../api/readSettings";
import { useSettingStore } from "shared/setting/stores/settingStore";
import { useRefreshStore } from "@/common/composables/refreshStore";

export const useRefreshSettingStore = defineStore('refresh-setting-store', () => {
  const readSettings = useReadSettings();
  const store = useSettingStore();

  const {
    initialize, refresh
  } = useRefreshStore<ReadSettingsResponse>({
    fetchFromServer() {
      return readSettings.execute();
    },
    mergeToStore(response) {
      // Apply minZoom from API if set, otherwise keep permissive default
      const minZoom = response.setting.sharedClient.map.minZoom ?? 3;
      store.setting = {
        ...response.setting,
        sharedClient: {
          ...response.setting.sharedClient,
          map: {
            ...response.setting.sharedClient.map,
            minZoom
          }
        }
      };
    },
  });

  return {
    initialize,
    refresh
  };
});
